import { useStores } from '../../../app/root/domain/stores/useStores';

export function useLoyaltyAccountStore() {
	const { loyaltyAccountStore } = useStores();

	return loyaltyAccountStore;
}
